import { render, staticRenderFns } from "./msTh.vue?vue&type=template&id=66bafcfa&scoped=true"
import script from "./msTh.vue?vue&type=script&lang=js"
export * from "./msTh.vue?vue&type=script&lang=js"
import style0 from "./msTh.vue?vue&type=style&index=0&id=66bafcfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bafcfa",
  null
  
)

export default component.exports